<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Paragraph"> </p>
<h1 class="P_Heading_1"><span> </span></h1>
<p class="P_Scene_separator" id="auto_bookmark_toc_4"><span>For the two. They know who they are.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?3a975417